import { Injectable } from 'angular-ts-decorators';

import type { IConfig } from '@shared/app/scripts/services/config';
import type { IStandardErrorParser } from '@shared/app/scripts/services/standard-error-parser';
import { Domain } from '@shared/app/scripts/services/domain';
import { Sentry } from '@shared/app/scripts/services/sentry';
import { SpynlBase } from '@shared/app/scripts/services/spynl-base';

/**
 * Simple service to access /discount-rules endpoints. Methods are inherited
 * form {@link shared.spynlBase spynlBase} service, and are documented there.
 */
@Injectable('discountRules')
export class DiscountRules extends SpynlBase<Object> {
  constructor(
    protected $http: ng.IHttpService,
    protected $q: ng.IQService,
    protected sentry: Sentry,
    protected domain: Domain,
    protected config: IConfig,
    protected standardErrorParser: IStandardErrorParser,
  ) {
    'ngInject';

    super($http, $q, sentry, domain, config, standardErrorParser, Object);

    this.location = '/pos_discountrules';
  }
}
